const appName = process.env.VUE_APP_NAME ?? "Ubamarket Backend";
const version = process.env.VUE_APP_VERSION ?? "";

const firebase = {
  ApiKey: process.env.VUE_APP_FIREBASE_API_KEY ?? "",
  AppId: process.env.VUE_APP_FIREBASE_APP_ID ?? "",
  AuthDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN ?? "",
  MeasurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID ?? "",
  MessagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID ?? "",
  ProjectId: process.env.VUE_APP_FIREBASE_PROJECT_ID ?? "",
  StorageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET ?? "",
};

const backend = {
  ApiKey: process.env.VUE_APP_BACKEND_API_KEY ?? "",
  url: process.env.VUE_APP_BACKEND_URL ?? "",
};

export const config = {
  appName,
  version,
  firebase,
  backend,
};
